import { FunctionalComponent, h } from 'preact';

import { stringToggle } from 'common/helper/string/toggle';
import { Gallery2CssClassEnum } from 'common/module/gallery-2/cssClass.enum';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';

import { ProgressiveImageComponentPropsInterface } from '../progressive-image/component-props.interface';

/**
 * Gallery image template
 */
export const Gallery2ImageTemplate: FunctionalComponent<ProgressiveImageComponentPropsInterface> = (props) => (
  <ProgressiveImageComponent
    {...props}
    classname={`${Gallery2CssClassEnum.itemClass} ${stringToggle(props.classname)(!!props.classname)}`}
  />
);
